import React from 'react';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';
import Select, {Option} from '../../../components/common/Select';
import {type TypedTranslation} from '../../../../i18n';

interface FormSelectProps {
    name: string;
    options: Option[];
    value?: Option;
    onChange: (name: string, value: string | string[] | undefined) => void;
    label: string;
    placeholder?: string;
    errors: string[];
}

function FormSelect({name, options, value, onChange, label, placeholder, errors}: FormSelectProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className={classNames('c-field', {'is-invalid': errors})}>
            <label>{label}</label>
            <Select
                className="c-sidepanel__reSelect"
                name={name}
                placeholder={placeholder || label}
                value={value}
                options={options}
                onChange={(e) => onChange(name, e?.value)}
            />

            {errors?.map((err) => (
                <div key={err} className="c-form-help is-invalid">
                    {t(err as TypedTranslation)}
                </div>
            ))}
        </div>
    );
}

export default FormSelect;
